import {ServiceRequest} from '../../model/ServiceRequest'
import './DownloadServiceFile.scss'
import {useGetServiceRequestFileMutation} from '../rtkServiceRequestApi'
import Button from '@mui/material/Button'


export const DownloadServiceFile = ({userServiceRequest}: { userServiceRequest: ServiceRequest }) => {
    const [getServiceRequestFile, {isLoading}] = useGetServiceRequestFileMutation()

    const getFile = () => {
        getServiceRequestFile(userServiceRequest.id)
    }

    if (!userServiceRequest?.file?.name) {
        return <></>
    }

    if (userServiceRequest?.file?.status !== 'Valid') {
        return <div className="text-error"
                    title={userServiceRequest?.file?.status}>{userServiceRequest?.file?.status}</div>
    }

    return <Button className="service-request-table-file-name" type="button"
                          loading={isLoading}
                          onClick={() => getFile()} title={userServiceRequest?.file?.name}>
        <span className="button-label">{userServiceRequest?.file?.name}</span>
    </Button>
}